import { useLang, isPhoneOpen, waLink } from "@/i18n";
import { meta } from "@/analytics/metaPixel";
import { Clock, MessageCircle } from "lucide-react";

export default function PhoneHours({ dark = false, className = "" }) {
  const { t } = useLang();
  const open = isPhoneOpen();
  return (
    <span
      data-testid="phone-hours"
      className={`inline-flex flex-wrap items-center gap-x-1.5 gap-y-1 text-[11px] font-semibold ${dark ? "text-[#9BDDF7]" : "text-[#64748B]"} ${className}`}
    >
      <Clock size={11} className="shrink-0" />
      <span>{t("phone.hours")}</span>
      <span className={open ? (dark ? "text-green-300" : "text-green-600") : (dark ? "text-amber-300" : "text-amber-600")}>
        · {t(open ? "phone.open" : "phone.closed")}
      </span>
      {!open && (
        <a
          data-testid="phone-hours-wa-btn"
          href={waLink(t("wa.prefill"))}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => meta.contact({ content_name: "after_hours_whatsapp" })}
          className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 border ${dark ? "border-[#25D366]/60 text-[#25D366] hover:bg-[#25D366] hover:text-[#003087]" : "border-[#25D366] text-[#128C4B] hover:bg-[#25D366] hover:text-white"} transition-colors duration-200`}
        >
          <MessageCircle size={10} /> {t("phone.wa")}
        </a>
      )}
    </span>
  );
}

export function trackCall(source) {
  meta.contact({ content_name: source, phone: "3713142397" });
}
